/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Auth0Provider, AppState } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "";
const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN ?? "";

// Detect both headless and windowed browser modes
const isE2ETest = window.playwright != null || window.navigator.webdriver;

type Props = {
  children: React.ReactNode;
};

export function Auth0ProviderWithHistory({ children }: Props) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      useRefreshTokens={isE2ETest === false}
      cacheLocation={isE2ETest ? "localstorage" : "memory"}
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}
